import { Plugin } from 'prosemirror-state'
import { AIRevisionPluginKey } from './constants'
import { AIRevision as AIRevisionMarkView } from 'common/Prose/markViews/AIRevision/AIRevision'
import { AIRevisionView } from 'common/Prose/Plugins/AIRevision/AIRevisionView'
import { InitConfig } from './Types'

export const AIRevision = ({ queryClient, articleId, layerId, stackManager }: InitConfig) =>
  new Plugin({
    key: AIRevisionPluginKey,
    state: {
      init() {
        return {
          queryClient,
          articleId,
          layerId,
          stackManager,
        }
      },
      apply(_, currentPluginState) {
        return currentPluginState
      },
    },
    props: {
      nodeViews: {
        ai_revision: (node, _view, _getPos, _decorations) => new AIRevisionMarkView(node),
      },
    },
    view(view) {
      return new AIRevisionView(view)
    },
  })
